// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 取消未绑定的任务上传 POST /bossApi/conference/core/processTask/v1/cancelAttachment */
export async function cancelBossProcessTaskAttachment(
  body: CoreAPI.ProcessAttachmentUploadRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/processTask/v1/cancelAttachment',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 验收任务文件上传 POST /bossApi/conference/core/processTask/v1/completeAttachment */
export async function completeBossProcessTaskAttachment(
  body: CoreAPI.ProcessAttachmentUploadRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseProcessAttachmentReadyDTO>(
    '/bossApi/conference/core/processTask/v1/completeAttachment',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取合法引用文件的短期地址 POST /bossApi/conference/core/processTask/v1/getAttachmentAccess */
export async function getBossProcessTaskAttachmentAccess(
  body: CoreAPI.ProcessAttachmentAccessRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseProcessAttachmentAccessDTO>(
    '/bossApi/conference/core/processTask/v1/getAttachmentAccess',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 创建任务文件直传会话 POST /bossApi/conference/core/processTask/v1/initAttachment */
export async function initBossProcessTaskAttachment(
  body: CoreAPI.ProcessAttachmentInitRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseProcessAttachmentInitDTO>(
    '/bossApi/conference/core/processTask/v1/initAttachment',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
